import { useCallback, useRef } from 'react';
import { Button } from '@salecycle/ui-component-library';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useTemplateEditorState } from '../../../../context/UseTemplateEditorContext';
import { PreviewRequired } from '../../../style';
import { usePreviewTemplate } from '../../../../hooks/usePreviewTemplate';
import { useListenAndUpdateTemplateAndPreview } from '../../../../hooks/useListenAndUpdateTemplateAndPreview';
import { useListenForTemplateChange } from '../../../../hooks/useListenForTemplateChange';

const PreviewInfoPanel = styled.div`
  flex-grow: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  word-break: break-word;
`;

export const PreviewRequiredView = () => {
  const { requiresPreview } = useTemplateEditorState();
  const { t } = useTranslation('designs');

  const isPreviewButtonClicked = useRef(false);
  const { previewTemplate, data } = usePreviewTemplate();

  const handlePreviewUpdate = useCallback(() => {
    isPreviewButtonClicked.current = false;
    previewTemplate();
  }, [previewTemplate]);

  useListenAndUpdateTemplateAndPreview(isPreviewButtonClicked, data);
  useListenForTemplateChange(handlePreviewUpdate);

  const handlePreviewButtonClicked = useCallback(() => {
    handlePreviewUpdate();
    isPreviewButtonClicked.current = true;
  }, [handlePreviewUpdate, isPreviewButtonClicked]);

  return (
    <PreviewRequired data-testid="PreviewRequiredView">
      <PreviewInfoPanel>
        <Button
          data-testid="PreviewButton"
          variation="primary"
          type="button"
          onClick={handlePreviewButtonClicked}
          disabled={!requiresPreview}
        >
          {t('designs:designGallery.templateEditor.previewRequiredView.button.text')}
        </Button>
      </PreviewInfoPanel>
    </PreviewRequired>
  );
};
